import { render, staticRenderFns } from "./ModalDeleteAccount.vue?vue&type=template&id=d9666078&scoped=true&"
import script from "./ModalDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteAccount.vue?vue&type=style&index=0&id=d9666078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9666078",
  null
  
)

export default component.exports